import { Method } from './DataUtils.js';
import * as DataUtils from './DataUtils.js';
import * as DTOs from '../DTOs/ClubDTOs.js';

export const PreFiltro = {
  TODOS: 'todos',
  CLUB_RIVAL: 'club_rival',
  SELECCION_RIVAL: 'seleccion_rival',
};

export const PostNuevoClub = async (pais, nombre) => {
  const idNuevo = await DataUtils.SaveObject(
    Method.POST,
    'clubes',
    DTOs.saveNuevoClub(pais, nombre)
  );
  return idNuevo;
};

export const GetClubes = async (prefiltro, objetoFiltro, pais, nombre) => {
  let url = null;
  let separador = '?';
  switch (prefiltro) {
    case PreFiltro.CLUB_RIVAL: {
      url = 'clubes/' + objetoFiltro.id + '/rivales/clubes';
      break;
    }
    case PreFiltro.SELECCION_RIVAL: {
      url = `selecciones_pais/${objetoFiltro.idPais}/rivales/clubes`;
      if (objetoFiltro?.categoria?.id) {
        url += `?categoria=${objetoFiltro.categoria.id}`;
        separador = '&';
      }
      break;
    }
    case PreFiltro.TODOS:
    default: {
      url = 'clubes';
      break;
    }
  }
  if (pais) {
    url += separador + 'pais=' + pais.id;
    separador = '&';
  }
  if (nombre) {
    url += separador + 'nombreParcial=' + nombre;
  }
  const clubes = await DataUtils.FetchLista(url);
  return clubes;
};

export const SearchClubes = async (pais, nombre) => {
  const clubes = await DataUtils.SearchLista('clubes/filtros', DTOs.searchClubes(pais, nombre));
  return clubes;
};
